var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFoursFringandFrLogoFringand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 756.938,
    height: 110.71,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 139.227,
    y1: 75.517,
    x2: 874.938,
    y2: 75.517
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#707173"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M181.054 93.774c-2.918 8.105-9.785 12.163-20.606 12.163l17.521-48.672c2.924-8.116 9.792-12.171 20.605-12.171h34.482c8.522 0 12.779 2.52 12.779 7.545 0 1.361-.308 2.896-.929 4.626h-50.712l-4.38 12.168h33.065c-2.919 8.109-9.786 12.168-20.603 12.168h-16.843l-4.379 12.173z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 139.227,
    y1: 75.517,
    x2: 874.933,
    y2: 75.517
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#707173"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M301.369 69.434c1.352 0 2.271-.673 2.759-2.025l2.917-8.116c.136-.354.208-.662.208-.934 0-.727-.502-1.093-1.502-1.093h-32.452l-13.142 36.509c-2.925 8.105-9.789 12.163-20.605 12.163l21.907-60.843h50.701c8.52 0 12.775 2.52 12.775 7.545 0 1.361-.31 2.896-.936 4.626l-4.378 12.168c-2.782 7.762-9.206 11.802-19.266 12.126l6.125 24.378h-20.284l-9.167-36.504h24.34z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 139.235,
    y1: 75.517,
    x2: 874.908,
    y2: 75.517
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#707173"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M340.551 45.095h16.224l-17.521 48.68c-2.921 8.105-9.794 12.163-20.606 12.163l21.903-60.843z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 139.222,
    y1: 75.517,
    x2: 874.942,
    y2: 75.517
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#707173"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "m409.101 85.659 10.224-28.394c2.918-8.116 9.788-12.171 20.607-12.171l-21.907 60.843h-8.116c-6.753 0-11.189-2.699-13.298-8.104l-18.743-32.452-14.603 40.557h-16.226l21.904-60.843h8.115c6.757 0 11.209 2.709 13.346 8.113l18.697 32.451z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 139.23,
    y1: 75.517,
    x2: 874.933,
    y2: 75.517
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#707173"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M465.969 57.266c-1.35 0-2.27.68-2.758 2.026l-11.685 32.451c-.128.348-.197.662-.197.934 0 .732.5 1.098 1.498 1.098h30.426c1.35 0 2.271-.679 2.759-2.031l3.653-10.142h-10.142c-8.521 0-12.778-2.511-12.778-7.543 0-1.352.311-2.888.932-4.625h42.591l-8.765 24.341c-2.918 8.105-9.787 12.163-20.606 12.163h-34.478c-8.517 0-12.776-2.511-12.776-7.537 0-1.358.311-2.894.928-4.626l13.147-36.509c2.917-8.116 9.791-12.171 20.601-12.171h34.484c8.516 0 12.781 2.52 12.781 7.545 0 1.361-.311 2.896-.934 4.626h-48.681z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: 139.222,
    y1: 75.517,
    x2: 874.931,
    y2: 75.517
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#707173"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M568.761 81.602h-34.479L529.9 93.774c-2.915 8.105-9.787 12.163-20.606 12.163l17.532-48.672c2.919-8.116 9.785-12.171 20.593-12.171h50.709l-21.907 60.843h-16.219l8.759-24.335zm8.76-24.336h-34.479l-4.379 12.168h34.481l4.377-12.168z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 139.206,
    y1: 75.517,
    x2: 874.946,
    y2: 75.517
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#707173"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "m650.457 85.659 10.225-28.394c2.917-8.116 9.787-12.171 20.609-12.171l-21.91 60.843h-8.115c-6.757 0-11.187-2.699-13.299-8.104l-18.742-32.452-14.604 40.557h-16.226l21.907-60.843h8.117c6.751 0 11.207 2.709 13.343 8.113l18.695 32.451z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 139.257,
    y1: 75.517,
    x2: 874.922,
    y2: 75.517
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#707173"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M692.884 91.743c-.123.348-.193.662-.193.934 0 .732.5 1.098 1.492 1.098h30.421c1.357 0 2.28-.679 2.771-2.031l11.678-32.451c.135-.354.207-.662.207-.934 0-.727-.504-1.093-1.507-1.093h-32.452c-8.516 0-12.772-2.517-12.772-7.542 0-1.353.307-2.9.937-4.629h50.697c8.523 0 12.775 2.52 12.775 7.545 0 1.361-.307 2.896-.934 4.626l-13.142 36.509c-2.921 8.105-9.788 12.163-20.606 12.163h-50.701l14.602-40.557h16.228l-9.501 26.362z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#BE0A26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.399 28.187c-1.688 4.706-5.677 7.041-11.928 7.041l10.138-28.174C191.307 2.351 195.284 0 201.55 0h19.963c4.93 0 7.391 1.46 7.391 4.374 0 .789-.178 1.677-.538 2.679h-29.357l-2.541 7.047h17.365c-1.694 4.69-5.672 7.041-11.937 7.041h-7.964l-2.533 7.046zM266.555 28.187c-1.693 4.706-5.669 7.041-11.927 7.041h-19.97c-4.927 0-7.391-1.447-7.391-4.358 0-.792.168-1.678.539-2.683l7.599-21.134C237.1 2.351 241.082 0 247.344 0h19.952c4.948 0 7.4 1.46 7.4 4.374 0 .789-.17 1.677-.524 2.679l-7.617 21.134zm-8.969-1.178 6.75-18.777c.087-.217.122-.39.122-.548 0-.424-.283-.631-.861-.631H245.98c-.783 0-1.312.39-1.607 1.179l-6.751 18.777a1.485 1.485 0 0 0-.114.546c0 .418.28.631.857.631h17.615c.799.001 1.315-.394 1.606-1.177zM283.422 27.009a1.418 1.418 0 0 0-.117.546c0 .418.284.631.865.631h17.607c.796 0 1.318-.395 1.609-1.177L313.097 0h9.4l-10.143 28.187c-1.695 4.706-5.677 7.041-11.937 7.041h-19.963c-4.926 0-7.395-1.447-7.395-4.358 0-.792.181-1.678.546-2.683L283.744 0c4.925 0 7.395 1.46 7.395 4.374 0 .789-.167 1.677-.539 2.679l-7.178 19.956zM352.656 14.1c.781 0 1.303-.399 1.594-1.175l1.691-4.693c.072-.217.116-.39.116-.548 0-.424-.286-.631-.867-.631h-18.787l-7.613 21.134c-1.697 4.706-5.668 7.041-11.926 7.041L329.54 0h29.354c4.938 0 7.398 1.46 7.398 4.374 0 .789-.169 1.677-.538 2.679l-2.536 7.047c-1.602 4.494-5.326 6.834-11.143 7.013l3.539 14.114h-11.751L338.564 14.1h14.092zM406.482 21.14l-2.544 7.046c-1.696 4.706-5.665 7.041-11.93 7.041h-19.963c-4.927 0-7.396-1.447-7.396-4.358 0-.792.186-1.678.54-2.683h28.178c.786 0 1.318-.395 1.601-1.177l1.689-4.688c.08-.207.118-.39.118-.546 0-.416-.292-.635-.862-.635h-18.791c-4.936 0-7.401-1.447-7.401-4.359 0-.789.188-1.683.54-2.681l2.532-7.047C374.483 2.351 378.472 0 384.726 0h19.97c4.925 0 7.393 1.46 7.393 4.374 0 .789-.182 1.677-.542 2.679h-28.181c-.782 0-1.312.39-1.593 1.179l-1.688 4.693a1.33 1.33 0 0 0-.119.531c0 .429.291.644.864.644h18.796c4.933 0 7.387 1.454 7.387 4.359 0 .793-.173 1.683-.531 2.681z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#A81528",
    d: "M26.693 35.249c0-1.959.229-3.892.627-5.791-6.91 9.984-12.338 22.543-16.324 37.749L0 109.002c-.024.098.007.193.025.296L0 109.38c-.086.338.058.675.403.931.347.255.852.399 1.385.399h78.151c25.114 0 44.246-9.331 57.799-28.338a152.421 152.421 0 0 1-23.778 1.854c-48.2 0-87.267-21.932-87.267-48.977z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#BE0A26",
    d: "M163.92.189H85.765c-25.512 0-44.857 9.642-58.444 29.269-.398 1.898-.627 3.831-.627 5.791 0 27.045 39.067 48.977 87.267 48.977a152.3 152.3 0 0 0 23.778-1.854c7.218-10.133 12.858-23.002 16.965-38.679l11-41.794c-.001-.812-.223-1.71-1.784-1.71z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 44.664,
    y1: 120.15,
    x2: 157.039,
    y2: -69.617
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f6a800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.018,
    style: {
      stopColor: "#f5a500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    style: {
      stopColor: "#d55e20"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    style: {
      stopColor: "#c42c26"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    style: {
      stopColor: "#be0a26"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    fill: "url(#i)",
    d: "M163.92.189H85.765c-25.512 0-44.857 9.642-58.444 29.269-.398 1.898-.627 3.831-.627 5.791 0 27.045 39.067 48.977 87.267 48.977a152.3 152.3 0 0 0 23.778-1.854c7.218-10.133 12.858-23.002 16.965-38.679l11-41.794c-.001-.001.527-1.71-1.784-1.71z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m116.35 70.679-34.491.064c-11.817 0-16.427 7.146-18.729 15.873l-4.54 17.383H47.958l4.916-18.645C56.286 72.3 63.948 55.882 85.43 55.882h34.861l-3.941 14.797z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M34.192 103.999H14.77c-.434 0-.839-.115-1.122-.328s-.398-.482-.331-.753l8.962-34.062c9.629-36.754 29.56-54.62 60.933-54.62h66.166c.433 0 .843.118 1.126.329.278.209.398.487.326.757l-9.67 27.029c-.117.446-.729.771-1.449.771l-63.01.116c-17.51 0-27.614 8.705-32.773 28.229l-8.285 31.755c-.112.449-.73.777-1.451.777zM70.208 104.016l2.886-10.529c1.811-6.598 13.806-7.388 21.751-7.403l7.495-.019.005-.021 4.962-.008-.004.019-.88 3.171-1.012 3.721c-1.406 5.131-5.357 10.987-14.612 11.006l-10.685.02-.011.017-9.895.026z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoursFringandFrLogoFringand);
export default __webpack_public_path__ + "static/media/fours-fringand-fr__logo-fringand.dba21b26d6530fc5cf546b9e2612c278.svg";
export { ForwardRef as ReactComponent };